import { GA_EVENTS } from './constants';

/**
 * Parameters of the events whose helpers forward an object built by the caller (search pages),
 * so the helper alone cannot tell which keys an event carries. Every other event's parameters are
 * fixed by its helper in ga4.js and captured by __tests__/gtmFieldContract.test.js.
 *
 * pushEvent logs an error in DEV/STG when one of these events carries an undeclared key, and the
 * contract test checks these keys against the GTM tags, like the captured ones. search_executed is
 * checked against the builders in searchEventParams.js; its advanced_criteria_expanded comes from
 * the call site in ProfilerSearch.jsx.
 */
export const FORWARDED_EVENT_PARAMS = {
  [GA_EVENTS.search_executed]: [
    'search_profile',
    'search_type',
    'industry_keyword_count',
    'value_chain_keyword_count',
    'product_portfolio_keyword_count',
    'industries_select_count',
    'industry_sections',
    'industry_codes',
    'situation_count',
    'listing_status_count',
    'shareholder_structure_count',
    'ownership_basis',
    'sales_min',
    'sales_max',
    'cagr_min',
    'cagr_max',
    'ebit_margin_min',
    'ebit_margin_max',
    'employees_min',
    'employees_max',
    'country_count',
    'filters_used',
    'total_filters_applied',
    'advanced_criteria_expanded'
  ],
  [GA_EVENTS.search_results_displayed]: [
    'search_profile',
    'search_type',
    'result_count',
    'has_results'
  ],
  [GA_EVENTS.search_result_clicked]: [
    'search_profile',
    'search_type',
    'result_type',
    'result_id',
    'result_position'
  ]
};
